import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDashboard } from "../../../store/actions/Authentication";
import ListCard from "./List/ListCard";
import { getUserDashboard } from "../../../store/services/Authentication";
import {
  setActiveList,
  setList,
  setListItems,
  setLists,
} from "../../../store/actions/Store/list";
import Loader from "components/Loader";
import { getUserProfile } from "store/services/Profile/profile";
import { setProfile } from "store/actions/Profile/profile";
export const Dashboard = () => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { lists } = useSelector((store) => store.storeLists);
  let userReducer = useSelector((store) => store.userReducer);
  const user = userReducer.user;
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openedSettingsId, setOpenedSettingsId] = useState(null);

  const [openSharedListId, setOpenSharedListId] = useState(null);

  const handleSharedToggle = (id) => {
    if (openedSettingsId) {
      handleSettingsToggle(null);
    }
    setOpenSharedListId((prevId) => (prevId === id ? null : id));
  };
  const handleSettingsToggle = (id) => {
    setOpenSharedListId(null);
    setOpenedSettingsId((prevId) => (prevId === id ? null : id));
  };

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  const props = {
    isOpen: isModalOpen,
    handleClose: handleModalToggle,
  };

  useEffect(() => {
    if (selectedStore) {
      const fetchData = async () => {
        try {
          const result = await getUserDashboard({
            store_id: selectedStore.id,
            user_id: user?.data?.id,
            token: user?.accessToken,
          });
          if (result.data) {
            if (selectedStore.isWhiteLabel) {
              const ownerLists = result.data.lists
                .filter((li) => li.owner === true)
                .sort((a, b) => a.isOrderPlaced - b.isOrderPlaced);
              dispatch(setLists(ownerLists));
            } else {
              const orderedLists = result?.data?.lists.sort(
                (a, b) => a.isOrderPlaced - b.isOrderPlaced
              );
              dispatch(setLists(orderedLists && orderedLists));
            }
            const activeList = result.data.lists.find(
              (aL) => aL.active === true
            );
            dispatch(setActiveList(activeList));
            dispatch(setList(activeList));
            dispatch(setListItems(result.data.lists));
            dispatch(getDashboard(result.data));
            if (user) {
              const profile = await getUserProfile(
                user.accessToken,
                user.data.id
              );
              if (profile.success) {
                dispatch(setProfile(profile.data));
              }
            }
          } else if (!result.success) {
            console.error("Error calling dashboard");
          }
        } catch (error) {
          console.error("Error calling dashboard:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    } else {
      setIsLoading(false);
    }
  }, [selectedStore, user, dispatch]);

  return (
    <div className="w-full min-h-screen mt-0 ">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="w-full ">
          {lists && lists.length > 0 ? (
            <section className="min-h-screen py-12 ">
              <div className="min-h-screen margin">
                <div className="grid gap-8 mt-12 lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 4xl:grid-cols-3 ">
                  {lists.map((li) => {
                    return (
                      <ListCard
                        key={li.list_id}
                        props={props}
                        li={li}
                        openedSettingsId={openedSettingsId}
                        handleSettingsToggle={handleSettingsToggle}
                        openSharedListId={openSharedListId}
                        handleSharedToggle={handleSharedToggle}
                      />
                    );
                  })}
                </div>
              </div>
            </section>
          ) : (
            <section className="flex flex-col items-center justify-center h-screen text-center md:flex-row lg:flex-row">
              <div>User has not yet created a list. </div>
              <span className="hidden lg:inline md:inline"> &nbsp;</span>
              <div> Press the + button on top to create a list</div>
            </section>
          )}
        </div>
      )}
    </div>
  );
};
